/** Fallback radius (in miles) used by every distance filter when nothing is stored. */
export const DEFAULT_DISTANCE_MILES = 50;

/** Label shown on a distance filter trigger/chip; always states the active radius. */
export function formatDistanceFilterLabel(distanceMiles: number): string {
  return `Within ${distanceMiles} miles`;
}
